module.exports = __webpack_public_path__ + "static/media/Jam1.1d6a27ed.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/Jam1.svg
// module id = 602
// module chunks = 0